import { CSS_PARAM, FUNNEL_NAME } from './quiz';

import welcome1 from '../images/quiz/collage_welcome_1.webp';
import welcome2 from '../images/quiz/collage_welcome_2.webp';
import welcome3 from '../images/quiz/collage_welcome_3.webp';
import welcome4 from '../images/quiz/collage_welcome_4.webp';
import final1 from '../images/quiz/collage_final_1.webp';
import final2 from '../images/quiz/collage_final_2.webp';
import final3 from '../images/quiz/collage_final_3.webp';
import final4 from '../images/quiz/collage_final_4.webp';
import black1 from '../images/quiz/collage_black_1.webp';
import black2 from '../images/quiz/collage_black_2.webp';
import black3 from '../images/quiz/collage_black_3.webp';
import black4 from '../images/quiz/collage_black_4.webp';
import christianNg from '../images/quiz/collage_christian_ng.webp';
import christianBlack from '../images/quiz/collage_christian_black.webp';
import christianLatam from '../images/quiz/collage_christian_latam.webp';

const BLACK = [black1, black2, black3, black4];

const DEFAULT_SET = {
  welcome: [welcome1, welcome2, welcome3, welcome4],
  final: [final1, final2, final3, final4],
};

const BLACK_SET = { welcome: BLACK, final: BLACK };

const CHRISTIAN_NON_GEO = { vertical: christianNg };

const COLLAGES_BY_FUNNEL = {
  long: { default: DEFAULT_SET, b: BLACK_SET },
  short: { default: DEFAULT_SET, b: BLACK_SET },
  christian: {
    default: CHRISTIAN_NON_GEO,
    ng: CHRISTIAN_NON_GEO,
    b: { vertical: christianBlack },
    l: { vertical: christianLatam },
  },
};

export const pickCollage = (funnel, cssValue) => {
  const collages = COLLAGES_BY_FUNNEL[funnel];

  return Object.prototype.hasOwnProperty.call(collages, cssValue)
    ? collages[cssValue]
    : collages.default;
};

const COLLAGE = pickCollage(FUNNEL_NAME, new URLSearchParams(window.location.search).get(CSS_PARAM));

export const WELCOME_COLLAGE = COLLAGE.welcome;
export const FINAL_COLLAGE = COLLAGE.final;
export const VERTICAL_COLLAGE = COLLAGE.vertical;
